/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 7a20d3005e9d
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";
import { UpdateRequest, UpdateRequest$zodSchema } from "./updaterequest.js";

export type UpdateTransformationGlobals = { cloud_name?: string | undefined };

export const UpdateTransformationGlobals$zodSchema: z.ZodType<
  UpdateTransformationGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type UpdateTransformationRequest = {
  transformation: string;
  update_request: UpdateRequest;
};

export const UpdateTransformationRequest$zodSchema: z.ZodType<
  UpdateTransformationRequest
> = z.object({
  transformation: z.string().describe(
    "The transformation identifier. Can be either a named transformation (e.g., 'small_profile_thumbnail') or a transformation string (e.g., 'w_100,h_150,c_fill,g_auto').\n",
  ),
  update_request: UpdateRequest$zodSchema.describe(
    "The updated transformation definition.",
  ),
});

export type UpdateTransformationResponse = MessageResponse | ApiError;

export const UpdateTransformationResponse$zodSchema: z.ZodType<
  UpdateTransformationResponse
> = z.union([
  MessageResponse$zodSchema,
  ApiError$zodSchema,
]);
